var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticStyle:{"top":"10px","position":"relative"}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px"}},[_c('span',{staticStyle:{"font-size":"10px"},domProps:{"innerHTML":_vm._s('copyrights © '+new Date().getFullYear()+' Don Quijote Recepciones | all rights reserved')}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-338dd89e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 46
// module chunks = 1